
class Call {

    constructor(data) {
        this.populate(data);
    }

    populate(data) {
        data = data ? data : {};

        this.CallStatus = (typeof data.CallStatus !== 'undefined' ? parseInt(data.CallStatus) : null);
        this.Comments = (typeof data.Comments !== 'undefined' && data.Comments ? data.Comments : null);
        this.CompanyID = (typeof data.CompanyID !== 'undefined' && data.CompanyID ? data.CompanyID : null);
        this.CompanyName = (typeof data.CompanyName !== 'undefined' && data.CompanyName ? data.CompanyName : null);
        this.HoldDate = (typeof data.HoldDate !== 'undefined' && data.HoldDate ? data.HoldDate : null);
        this.KeyLocation = (typeof data.KeyLocation !== 'undefined' && data.KeyLocation ? data.KeyLocation : null);
        this.Location = (typeof data.Location !== 'undefined' && data.Location ? data.Location : null);
        this.LocationLatitude = (typeof data.LocationLatitude !== 'undefined' && data.LocationLatitude ? data.LocationLatitude : null);
        this.LocationLongitude = (typeof data.LocationLongitude !== 'undefined' && data.LocationLongitude ? data.LocationLongitude : null);
        this.Destination = (typeof data.Destination !== 'undefined' && data.Destination ? data.Destination : null);
        this.DestinationLatitude = (typeof data.DestinationLatitude !== 'undefined' && data.DestinationLatitude ? data.DestinationLatitude : null);
        this.DestinationLongitude = (typeof data.DestinationLongitude !== 'undefined' && data.DestinationLongitude ? data.DestinationLongitude : null);
        this.Odometer = (typeof data.Odometer !== 'undefined' && data.Odometer ? data.Odometer : null);
        this.OwnerName = (typeof data.OwnerName !== 'undefined' && data.OwnerName ? data.OwnerName : null);
        this.OwnerPhone = (typeof data.OwnerPhone !== 'undefined' && data.OwnerPhone ? data.OwnerPhone : null);
        this.PONumber = (typeof data.PONumber !== 'undefined' && data.PONumber ? data.PONumber : null);
        this.Reason = (typeof data.Reason !== 'undefined' && data.Reason ? data.Reason : null);
        this.RequestedBy = (typeof data.RequestedBy !== 'undefined' && data.RequestedBy ? data.RequestedBy : null);
        this.RequestedPhone = (typeof data.RequestedPhone !== 'undefined' && data.RequestedPhone ? data.RequestedPhone : null);
        this.TrailerNumber = (typeof data.TrailerNumber !== 'undefined' && data.TrailerNumber ? data.TrailerNumber : null);
        this.TruckNumber = (typeof data.TruckNumber !== 'undefined' && data.TruckNumber ? data.TruckNumber : null);
        this.VIN = (typeof data.VIN !== 'undefined' && data.VIN ? data.VIN : null);
        this.VehicleColor = (typeof data.VehicleColor !== 'undefined' && data.VehicleColor ? data.VehicleColor : null);
        this.VehicleMake = (typeof data.VehicleMake !== 'undefined' && data.VehicleMake ? data.VehicleMake : null);
        this.VehicleModel = (typeof data.VehicleModel !== 'undefined' && data.VehicleModel ? data.VehicleModel : null);
        this.VehiclePlate = (typeof data.VehiclePlate !== 'undefined' && data.VehiclePlate ? data.VehiclePlate : null);
        this.VehicleYear = (typeof data.VehicleYear !== 'undefined' && data.VehicleYear ? data.VehicleYear : null);

    }

}

module.exports = Call;